
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 * 聊天公告
 */
import {Component, Prop, Vue} from "vue-property-decorator";
import {SizeEnum} from "@/ts/Enum";

@Component
export default class ChatNotice extends Vue {
  @Prop() type: SizeEnum;
  @Prop() isNotice: boolean;
  @Prop() notice: string;

}
